import {
  Image,
} from './branchInterface';

export interface IDeglawyContentStore {
  deglawyContentsList: DeglawyContent[];
  selectedDeglawyContent: DeglawyContent;
  loading: boolean;

  getDeglawyContents(languageCode?: string): Promise<void>;

  updateDeglawyContent(updatedDeglawyContent: any, languageCode?: string): Promise<any>;

  updateDeglawyContentById(updatedDeglawyContent: any, id: number, languageCode?: string): Promise<any>;

  getDeglawyContentById(id: number, languageCode: string): Promise<void>;
}


export interface Media {
  mediaId: number,
  url: string
}
export class DeglawyContent {
  deglawyContentId: number;

  title: string;

  body: string;

  media: Media [];

  constructor() {
    this.deglawyContentId = 0;
    this.title = '';
    this.body = '';
    this.media = [];
  }

  setId(id: number): void {
    this.deglawyContentId = id;
  }

  getId(): number {
    return this.deglawyContentId;
  }

  setTitle(newTitle: string): void {
    this.title = newTitle;
  }

  getTitle(): string {
    return this.title;
  }

  setBody(newBody: string): void {
    this.body = newBody;
  }

  getBody(): string {
    return this.body;
  }

  getMedia(): Media [] {
    return this.media;
  } 

  setMedia(media: Media []): void {
    this.media = media;
  }
  getContentToUpdate(): { deglawyContentId: number; title: string; body: string, media: any []; } {
    return {
      deglawyContentId: this.deglawyContentId,
      title: this.title,
      body: this.body,
      media: this.media
    };
  }

  private getImageURL(image: (Image | File)): string | null {
    if (image && this.isImage(image)) {
      return image.imageUrl;
    }
    return null;
  }

  private isImage(image: any): image is Image {
    return 'imageUrl' in image;
  }
}
